import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import { ReportDashboardTemplatesResponse } from '@core/reports-types';

@Injectable({ providedIn: 'root' })
export class ReportsDashboardTemplatesHttpClient {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchCollection(): Observable<ReportDashboardTemplatesResponse> {
    return this.httpApi.get('/templates/dashboards');
  }
}
